// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"A3-z"};